import React from 'react';

import { type Control } from 'react-hook-form';

import type { MoodCategoryType } from '@/types/domain/childNotebook/valueObjects/moodCategory';
import type { HealthRecordTypeType } from '@/types/domain/class/valueObjects/healthRecordType';

import SelectFieldComp from '@/components/SelectFieldComp';
import TextFieldComp from '@/components/TextFieldComp';
import { MOOD_CATEGORY_TYPE } from '@/types/domain/childNotebook/valueObjects/moodCategory';

/**
 * 連絡帳入力
 */
export type PageInputType = {
  /** 気分 */
  moodType: MoodCategoryType,
  /** コメント */
  comment: string,
};

/**
 * 健康記録リストの型
 */
export type HealthRecordListType = {
  /** 種別 */
  type: HealthRecordTypeType,
  /** 時間 */
  time: Date,
  /** コンテンツ */
  content: string,
  /** 削除 */
  delete: () => void,
}[];

/**
 * 健康記録追加アクションの型
 */
export type HealthRecordAddAction = {
  [key in HealthRecordTypeType]: () => void;
};

/**
 * 連絡帳フォーム入力
 */
export type PageFormInputType = {
  /** コントロール */
  control: Control<PageInputType, any>,
  /** エラー */
  errors: any,
  /** コメント(文字カウント用) */
  comment: string,
  /** 機嫌を表示しない */
  hideCondition: boolean,
}

const PageFormInput: React.FC<PageFormInputType> = ({
  control,
  errors,
  comment,
  hideCondition,
}) => (
  <div>
    {!hideCondition && (
      <SelectFieldComp
        control={control}
        name="moodType"
        label="機嫌"
        rules={{
          required: '必須項目です',
        }}
        errors={errors}
        items={MOOD_CATEGORY_TYPE.map((v) => ({
          id: v,
          name: v,
        }))}
      />
    )}
    <TextFieldComp
      type="text"
      control={control}
      rules={{
        // 送信時に必須判定は呼び出し側で行う（下書きはコメントなし可）
        maxLength: { value: 1000, message: '最大1000文字です' },
      }}
      name="comment"
      label={`コメント (${comment.length}/1000文字)`}
      placeholder=""
      errors={errors}
      multiline
      rows={5}
    />
  </div>
);

export default PageFormInput;
